module.exports = __webpack_public_path__ + "img/17-full-md.53f7670e.jpg";